module.exports = __webpack_public_path__ + "img/realName.28618d0f.png";